<template>
  <div class="answer_show">
    <div class="answer_showCenter">
      <!--左-->
      <div class="answer_left">
        <div class="show_list">
          <div class="item_title">
            <div v-if="!answerInfo.coverUrl" class="top_info">
              <div class="answer_name">
                <div>?</div>
                <span>{{answerInfo.title}}</span>
              </div>
              <div class="answer_time">{{answerInfo.publishTime}}</div>
            </div>
            <div v-if="answerInfo.coverUrl" class="_top_info">
              <div class="coverUrl">
                <img :src="answerInfo.coverUrl" alt="">
              </div>
              <span>
                {{answerInfo.title}}
              </span>
            </div>
            <div class="bottom_mask"></div>
          </div>
          <div class="item_doctorInfo">
            <img :src="answerInfo.headImage" alt="">
            <div class="doctor_name">{{answerInfo.doctorName}}</div>
            <div class="doctor_call">{{answerInfo.doctorLevelName}}</div>
            <div class="doctor_hospital">{{answerInfo.hospitalName}}</div>
            <div class="doctor_callShow">{{answerInfo.departmentName}}</div>
          </div>
          <div class="item_text" v-html="answerInfo.content"></div>
        </div>
      </div>
      <!--右-->
      <div class="answer_right">
        <div class="title_box" style="margin-bottom: 30px">热门咨询</div>
        <div class="card_right_list">
          <div class="right_list_item" v-for="(item,index) in hotAnswerData" :key="item.id" @click="handleAnswerShow(item.id)">
            <div class="item_num">{{index+1}}</div>
            <div class="item_title">{{item.title}}</div>
            <div class="item_oneCard">
              <div class="oneCard_left">
                <img :src="item.coverUrl" alt="">
                <div>{{index+1}}</div>
              </div>
              <div class="oneCard_right">
                <div class="header">{{item.title}}</div>
                <div class="title">
                  <div>{{item.doctorName}}</div>
                  <span>{{item.doctorLevelName}}</span>
                </div>
                <!--<div class="time">2020-03-12</div>-->
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    data() {
      return {
        answerInfo:{},
        hotAnswerData:[],
      }
    },
    created(){
      console.log(this.$route)
    },
    methods:{
      // 获取详情信息
      getAnsertShow() {
        let params = {
          id:this.$route.params.id
        }
        this.$api.mykp_home.findVideoShow(params) .then(res => {
          if(res.code == '000000') {
            this.answerInfo = res.infos
          }
        })
      },
      // 获取热门列表
      getHotAnswerList() {
        const data = {
          type:1,
          doctorId:0
        }
        this.$api.mykp_home.findDetailsHotlist(data) .then(res => {
          if(res.code == '000000'){
            this.hotAnswerData = res.infos
          }
        })
      },
      // 点击问答
      handleAnswerShow(id) {
        this.$router.push({path:'/answerList/answeShow/'+id,query:{}})
      },
    },
    activated() {
      this.getAnsertShow()
      this.getHotAnswerList()
      var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?26e3d1e8dc2b426ced392180fb72861b";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
      console.log("统计")
    },
    // 调用当前组件时调用
    beforeRouteUpdate (to, from, next) {
      next()
      this.getAnsertShow()
      this.getHotAnswerList()
      var _hmt = _hmt || [];
      var hm = document.createElement("script");
      hm.src = "https://hm.baidu.com/hm.js?26e3d1e8dc2b426ced392180fb72861b";
      var s = document.getElementsByTagName("script")[0];
      s.parentNode.insertBefore(hm, s);
      console.log("统计")
    },
  }
</script>
<style lang="stylus" scoped>
  .answer_show{
    margin-top 30px
    .answer_showCenter{
      width: 1200px
      margin 0 auto
      display flex
      justify-content space-between
      .answer_left{
        width: 800px
        .show_list{
          .item_title{
            .top_info{
              display flex
              justify-content space-between
              align-items center
              .answer_name{
                display flex
                align-items center
                >div{
                  width: 50px;
                  height: 50px;
                  background: #1083f8
                  color: #fff
                  text-align: center
                  line-height: 50px
                  font-size 47px
                  margin-right 20px
                }
                >span{
                  font-weight: 700;
                  font-size: 20px;
                  color: #333
                  overflow: hidden;
                  text-overflow: ellipsis;
                  white-space: nowrap;
                  max-width 550px
                }
              }
              .answer_time{
                font-size: 12px;
                color: #C9C9C9;
              }
            }
            ._top_info{
              .coverUrl{
                width 780px;
                height:auto;
                margin-bottom:20px;
                img{
                  width:100%;
                  height:auto
                }
              }
              span{
                font-weight: 700;
                font-size: 20px;
                color: #333
                overflow: hidden;
                text-overflow: ellipsis;
                white-space: nowrap;
                max-width 550px
              }

            }
            .bottom_mask{
              width: 780px;
              height: 4px;
              background: #d7d7d7
              margin-top 20px
            }
          }
          .item_doctorInfo{
            margin-top 40px
            display flex
            align-items center
            >img{
              width: 60px;
              height: 60px;
              border-radius 50%
              margin-right 10px
            }
            .doctor_name{
              max-width 100px
              font-weight: 700;
              font-style: normal;
              font-size: 18px;
              color: #000000;
              margin-right 20px
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .doctor_call{
              max-width 150px
              font-size: 18px;
              color: #000000;
              margin-right 20px
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .doctor_hospital{
              max-width 300px
              font-size: 16px;
              color: #000000;
              margin-right 20px
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .doctor_callShow{
              max-width 150px
              font-size: 16px;
              color: #000000;
              margin-right 20px
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
          }
          .item_text{
            margin-top 20px
            font-size: 14px;
            line-height: 24px;
            color: #333
            text-indent 2em
          }
        }
      }
      .answer_right{
        width: 361px
        .card_right_list{
          .right_list_item{
            margin-top 14px
            display flex
            align-items center
            cursor: pointer
            &:nth-child(-n +3){
              display block
              padding-bottom  10px
              .item_num{
                display none
              }
              .item_title{
                display none
              }
              .item_oneCard{
                display flex
              }
              &:after {
                content ''
                display flex
                width: 361px
                height: 1px
                border-top 1px dashed #eee
                margin-top 20px
                transform translateY(3px)
              }
            }
            .item_num{
              width: 35px;
              height: 29px;
              text-align: center
              line-height 29px
              font-size: 18px;
              color: #A1A1A1;
              border 1px solid #e4e4e4
              margin-right 15px
            }
            .item_title{
              font-size: 16px;
              color: #333
              width 80%
              overflow: hidden;
              text-overflow: ellipsis;
              white-space: nowrap;
            }
            .item_oneCard{
              display none
              .oneCard_left{
                position relative
                >img{
                  width: 148px;
                  height: 93px;
                }
                >div{
                  position absolute
                  bottom:3px
                  left: 0
                  width: 35px;
                  height: 29px;
                  text-align: center
                  line-height 29px
                  font-size: 18px;
                  color: #fff;
                  background #ff8a8a
                  margin-right 15px
                }
              }
              .oneCard_right{
                margin-left 20px
                width: 185px
                .header{
                  max-width 200px
                  font-weight: 700;
                  font-size: 18px;
                  color: #333
                  line-height: 24px
                  text-overflow: -o-ellipsis-lastline;
                  overflow: hidden;
                  text-overflow: ellipsis;
                  display: -webkit-box;
                  -webkit-line-clamp: 2;
                  -webkit-box-orient: vertical;
                }
                .title{
                  margin-top 15px
                  max-width 200px
                  display flex
                  >div{
                    font-size: 16px;
                    color: #A1A1A1;
                    max-width: 40%
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                    margin-right  10px
                  }
                  >span{
                    font-size: 16px;
                    color: #A1A1A1;
                    max-width: 60%
                    overflow: hidden;
                    text-overflow: ellipsis;
                    white-space: nowrap;
                  }
                }
                .time{
                  margin-top 15px
                  font-size: 14px;
                  color: #C9C9C9;
                  text-align: right
                }
              }
            }
          }
        }
        .title_box{
          font-weight: 700;
          font-style: normal;
          font-size: 18px;
          width: 170px;
          height: 40px;
          background #1083f8
          text-align: center
          line-height:40px
          border-radius: 5px;
          color: #fff
        }
      }
    }
  }
</style>





// WEBPACK FOOTER //
// src/views/answer/Show.vue